import { useState } from "react";
import { navItems } from "@/mocks/home";

export default function SiteHeader() {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState("");

  const goTo = (id: string) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 w-full items-center gap-4 px-4 md:px-6">
        <button
          type="button"
          onClick={() => goTo("top")}
          className="flex shrink-0 items-center gap-2.5"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-book-2-line text-lg" />
          </span>
          <span className="flex flex-col items-start leading-none">
            <span className="font-heading text-base font-bold text-foreground-950">
              善良的女秘书
            </span>
            <span className="mt-0.5 text-[11px] font-label tracking-wide text-foreground-500">
              全文 · 有声 · 合集
            </span>
          </span>
        </button>

        <nav className="ml-6 hidden items-center gap-1 lg:flex">
          {navItems.map((item) => (
            <button
              key={item.id}
              type="button"
              onClick={() => goTo(item.id)}
              className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-label text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {item.label}
            </button>
          ))}
        </nav>

        <div className="ml-auto flex items-center gap-2">
          <div className="hidden items-center gap-1 rounded-full border border-background-300 bg-background-100 py-1 pl-3 pr-1 md:flex">
            <i className="ri-search-line text-sm text-foreground-500" />
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") goTo("chapters");
              }}
              placeholder="搜索章节 / 篇名"
              className="w-32 bg-transparent text-sm font-label text-foreground-800 outline-none placeholder:text-foreground-400 lg:w-40"
            />
            <button
              type="button"
              onClick={() => goTo("chapters")}
              className="whitespace-nowrap rounded-full bg-secondary-500 px-3 py-1.5 text-xs font-label text-background-50 transition-colors hover:bg-secondary-600"
            >
              查找
            </button>
          </div>

          <button
            type="button"
            onClick={() => goTo("chapters")}
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-label text-background-50 transition-colors hover:bg-primary-600 md:block"
          >
            立即阅读
          </button>

          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="菜单"
            className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-700 lg:hidden"
          >
            <i className={open ? "ri-close-line text-lg" : "ri-menu-line text-lg"} />
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 lg:hidden">
          <div className="flex flex-col">
            {navItems.map((item) => (
              <button
                key={item.id}
                type="button"
                onClick={() => goTo(item.id)}
                className="whitespace-nowrap rounded-md px-3 py-2.5 text-left text-sm font-label text-foreground-700 hover:bg-background-100"
              >
                {item.label}
              </button>
            ))}
          </div>
          <button
            type="button"
            onClick={() => goTo("chapters")}
            className="mt-2 w-full whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-label text-background-50"
          >
            立即阅读
          </button>
        </div>
      )}
    </header>
  );
}